import { useEffect, useRef, useState } from 'react';

const axios = require('axios').default;

export default function useSectionData(url, params, { lazy = false } = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(!lazy);
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const paramsKey = JSON.stringify(params);

  useEffect(() => {
    if (visible) return undefined;
    if (typeof window.IntersectionObserver === 'undefined' || !ref.current) {
      setVisible(true);
      return undefined;
    }
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: '600px' });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible]);

  useEffect(() => {
    if (!visible || !url) return undefined;
    let current = true;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    axios.get(url, { params })
      .then((res) => { if (current) setState({ data: res.data, loading: false, error: null }); })
      .catch((error) => { if (current) setState({ data: null, loading: false, error }); });
    return () => { current = false; };
  }, [url, paramsKey, visible]);

  return { ...state, ref };
}
